function changeKindSelect() {
  setDisabled();
  $('.form-absence-kind').click(function () {
    setDisabled();
  });
}

function setDisabled() {
  const checkedElements = $(".form-absence-kind:checked");

  // 全ての区分が未選択（選択していた区分が停止された）のとき
  if (checkedElements.length === 0) {
    toggleTime(false, false);
    toggleReason(false, false, false);
    changeRequireComment(false);
    return;
  }

  checkedElements.each(function () {
    switch ($(this).val()) {
      case 'absence':
        toggleTime(false, false);
        toggleReason(true, false, false);
        changeRequireComment(false);
        break;
      case 'late':
        toggleTime(true, false);
        toggleReason(false, true, false);
        changeRequireComment(false);
        break;
      case 'leave_early':
        toggleTime(false, true);
        toggleReason(false, false, true);
        changeRequireComment(false);
        break;
      case 'late_and_leave_early':
        toggleTime(true, true);
        toggleReason(false, true, true);
        changeRequireComment(false);
        break;
      case 'others':
        toggleTime(false, false);
        toggleReason(false, false, false);
        changeRequireComment(true);
        break;
    }
  });
}

function toggleTime(attendanceState, dismissalState) {
  // 全てが false のときは必須ラベルを外す
  if (!attendanceState && !dismissalState) {
    $('.require-times').hide();
  } else {
    $('.require-times').show();
  }

  $('.form-attendance-at').prop('disabled', !attendanceState);
  $('.form-dismissal-at').prop('disabled', !dismissalState);
}

function toggleReason(reasonState, lateReasonState, leaveEarlyReasonState) {
  // 全てが false のときは「理由」を非活性で表示する
  if (!reasonState && !lateReasonState && !leaveEarlyReasonState) {
    $('.require-reason').hide();
    $(".form-reason").attr("hidden", false).attr("disabled", true);
    $(".form-late-reason").attr("hidden", true).attr("disabled", true);
    $(".form-leave-early-reason").attr("hidden", true).attr("disabled", true);
    return;
  }

  $('.require-reason').show();
  $(".form-reason").attr("hidden", !reasonState).attr("disabled", !reasonState);
  $(".form-late-reason").attr("hidden", !lateReasonState).attr("disabled", !lateReasonState);
  $(".form-leave-early-reason").attr("hidden", !leaveEarlyReasonState).attr("disabled", !leaveEarlyReasonState);
}

function changeRequireComment(state) {
  if (state) {
    $('.require-comment').show();
  } else {
    $('.require-comment').hide();
  }

  $('.comment-textarea').prop('required', state);
}

window.changeKindSelect = changeKindSelect;
